import { v4 as uuid } from "uuid";

export const educationList = [
  {
    id: uuid(),
    number: 1,
    EducationName: "Synergy University",
    placce: "Runner Up - Webflow Expert Design",
    direction: "Project Management and Human Resources!",
    year: "2012—2017",
  },
  {
    id: uuid(),
    number: 2,
    EducationName: "Step IT",
    direction: "Python Developer",
    year: "2021",
  },
  {
    id: uuid(),
    number: 3,
    EducationName: "GoIt",
    direction: "FULL STACK",
    year: "2022-2023",
  },
  {
    id: uuid(),
    number: 4,
    EducationName: "Beetrootacademy",
    direction: "Front-End Developer",
    year: "2024-2025",
  },
];
